import React from 'react';
import site from '../../data/site';

/* Fixed bottom bar on phones: call intake or jump to the request form. */
const MobileBar = () => (
    <div className="sw-mobilebar">
        <a className="sw-mobilebar__btn sw-mobilebar__btn--ghost" href={site.phones[0].href}>Call intake</a>
        <a className="sw-mobilebar__btn" href="#contact">Request care</a>
    </div>
);

export default MobileBar;
